import React, { useState, useEffect } from 'react';
import { products } from '../data/mockData';
import ProblemFilters from './ProblemFilters';
import ProductCard from './ProductCard';
import { motion, AnimatePresence } from 'framer-motion';

const SkeletonCard = () => (
  <div className="dashboard-card h-[400px] bg-white animate-pulse">
    <div className="h-48 bg-slate-100" />
    <div className="p-5 space-y-4">
      <div className="h-4 w-1/4 bg-slate-100 rounded" />
      <div className="h-6 w-3/4 bg-slate-100 rounded" />
      <div className="space-y-2">
        <div className="h-3 w-full bg-slate-100 rounded" />
        <div className="h-3 w-5/6 bg-slate-100 rounded" />
      </div>
      <div className="pt-4 border-t border-slate-50 flex justify-between">
        <div className="h-8 w-20 bg-slate-100 rounded" />
        <div className="h-8 w-16 bg-slate-100 rounded" />
      </div>
    </div>
  </div>
);

const ProductGrid = () => {
  const [activeFilter, setActiveFilter] = useState('all');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading state for filter changes
    setIsLoading(true);
    const timer = setTimeout(() => setIsLoading(false), 800);
    return () => clearTimeout(timer);
  }, [activeFilter]);

  const filteredProducts = activeFilter === 'all' 
    ? products 
    : products.filter(p => p.category === activeFilter);

  return (
    <section className="py-24 bg-slate-50" id="hardware">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12">
          <div className="mono-label text-indigo-600 mb-2">Hardware Registry v1.0</div>
          <h2 className="text-3xl font-extrabold text-slate-900 mb-4">Component Database</h2>
          <p className="text-slate-500 max-w-2xl">
            Filter the registry by specific workspace friction points. All hardware is tested for multi-system compatibility and ergonomic compliance.
          </p>
        </div>

        <ProblemFilters activeFilter={activeFilter} setActiveFilter={setActiveFilter} />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 min-h-[600px]">
          <AnimatePresence mode="popLayout">
            {isLoading ? (
              [1, 2, 3, 4].map(i => <SkeletonCard key={i} />)
            ) : filteredProducts.length > 0 ? (
              filteredProducts.map(product => (
                <ProductCard key={product.id} product={product} />
              ))
            ) : (
              <motion.div 
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                className="col-span-full py-20 text-center"
              >
                <p className="text-slate-400 font-mono uppercase tracking-widest text-sm">Registry_Entry_Not_Found</p>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
};

export default ProductGrid;